import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { ClassroomContext } from './../providers/ClassroomProvider';
import { UseClassroom } from '../providers/ClassroomProvider/types';

const useClassrooms = (): UseClassroom => {
  const [state, dispatch] = useContextWithErrorHandler(ClassroomContext, 'ClassroomProvider');
  return [state, dispatch];
};

export default useClassrooms;
